/** @jsxImportSource theme-ui */
import Copy from "./Copy";
import IconContentful from "../components/IconContentful";
import IconElectron from "../components/IconElectron";
import IconFirebase from "../components/IconFirebase";
import IconGraphQL from "../components/IconGraphQL";
import IconJest from "../components/IconJest";
import IconJinja from "../components/IconJinja";
import IconMaterialDesign from "../components/IconMaterialDesign";
import IconNodeJS from "../components/IconNodeJS";
import IconProjectAC from "../components/IconProjectAC";
import IconProjectCWG from "../components/IconProjectCWG";
import IconProjectQCC from "../components/IconProjectQCC";
import IconProjectSTV from "../components/IconProjectSTV";
import IconProjectSemiPermanent from "../components/IconProjectSemiPermanent";
import IconPython from "../components/IconPython";
import IconReact from "../components/IconReact";
import IconSCSS from "../components/IconSCSS";
import IconStorybook from "../components/IconStorybook";
import IconTypeScript from "../components/IconTypeScript";

type Props = {
  className?: string;
  icon: string;
};

// TODO: Find a way to dynamically import the icons, without using React.lazy!
const icons = {
  IconContentful,
  IconElectron,
  IconFirebase,
  IconGraphQL,
  IconJest,
  IconJinja,
  IconMaterialDesign,
  IconNodeJS,
  IconProjectAC,
  IconProjectCWG,
  IconProjectQCC,
  IconProjectSTV,
  IconProjectSemiPermanent,
  IconPython,
  IconReact,
  IconSCSS,
  IconStorybook,
  IconTypeScript,
};

const ProjectIcon = ({ icon, ...props }: Props) => {
  // Detect whether icon is an emoji or a component name starting with "Icon"
  const isEmoji = !icon.startsWith("Icon");

  // Render the emoji
  if (isEmoji) {
    return (
      <Copy {...props} sx={{ fontSize: [28, null, 28], lineHeight: 1 }}>
        {icon}
      </Copy>
    );
  }

  // Render the Icon component
  const IconComponent = icons[icon];

  return <IconComponent {...props} />;
};

export default ProjectIcon;
